
import { Options, setup, Vue } from "vue-class-component";
import { computed, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import { useMeta } from "vue-meta";

@Options( {
  components : {
    Header : defineAsyncComponent( () => import("@/components/Header.vue") ),
    Footer : defineAsyncComponent( () => import("@/components/Footer.vue") )
  }
} )
export default class extends Vue
{
  store = useStore( key );

  departements = [];

  meta = setup( () => useMeta( computed( () => {
    return {
      title : [{
        content : "Location-gardemeuble.fr - Carton pas cher et emballage pour le déménagement ou le stockage",
        vmid    : "title",
        name    : "title"
      }],
      description : {
        content : "Obtenez 10% de réduction avec Location-gardemeuble sur vos cartons et matériel d’emballage pour déménager et stocker dans un box ou un garde-meuble.",
        vmid    : "description",
        name    : "description"
      }
    };
  } ) ) );

  mounted()
  {
    setTimeout( () => {
      this.store.state.loading = false;

      // Remove div#preload from DOM
      let preload = document.getElementById( "preload" );
      if( preload )
      {
        window.scrollTo( { top : 0 } );
        preload.remove();
      }
    }, this.store.state.delay );
  }
}
